import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  tabContainer: {
    marginBottom: "5rem",
  },
}); 